import { toast } from "react-toastify"

import { useDeleteNewOrderV2Mutation } from "store/api/ordersApi"
import { useDeleteVendorOrderNewMutation } from "store/api/vendorApi"

import getErrorMessage from "utils/getErrorMessage"

import { DeleteModal } from "../DeleteModal"

interface Props {
  orderId: number
  isVendor?: boolean
  onCancel: () => void
}

export const DeleteOrderModalNew = ({ orderId, isVendor, onCancel }: Props) => {
  const [triggerDeleteNewOrderV2, { isLoading }] = isVendor
    ? useDeleteVendorOrderNewMutation()
    : useDeleteNewOrderV2Mutation()

  const onSubmit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()

    try {
      const res = await triggerDeleteNewOrderV2(orderId)
      const error = getErrorMessage(res?.error)
      if (error) {
        toast.error(error)
      } else {
        toast.success("Order has been successfully deleted!")
        onCancel()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <DeleteModal
      title="Delete order"
      message="Are you sure you want to delete the selected order(s)?"
      isFetching={isLoading}
      onCancel={onCancel}
      onConfirm={onSubmit}
    />
  )
}
